// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pFwmGqScrtNlyHfFz3pg{margin-left:-12px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/tags/ui/TagsAction/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA","sourcesContent":[".deleteBulk {\n  margin-left: -12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteBulk": `pFwmGqScrtNlyHfFz3pg`
};
export default ___CSS_LOADER_EXPORT___;
